export default __webpack_public_path__ + "static/media/m-link-event.1acf0473.svg";